import { xAbsolute } from "../x/xAbsolute.js";
import { xMedian } from "../x/xMedian.js";
import { xSubtract } from "../x/xSubtract.js";
/**
 * Calculate the weights based on the control points and the MAD between the original data and the new baseline.
 * MAD (Median Absolute Deviation) is more robust to outliers and
 * the factor (1.4826) makes MAD scaled to be equivalent to the standard deviation for
 * normal distributions. {@link https://en.m.wikipedia.org/wiki/Median_absolute_deviation}.
 * @param yData - The original data.
 * @param baseline - The new baseline calculated.
 * @param weights - The current weights to be updated.
 * @param options - Options for updating weights.
 * @returns new array of weights.
 */
export function calculateAdaptiveWeights(yData, baseline, weights, options) {
    const { controlPoints, factorStd = 3, learningRate = 0.5 } = options;
    if (learningRate === 0) {
        return weights;
    }
    const absResiduals = xAbsolute(xSubtract(yData, baseline));
    const medAbsRes = xMedian(absResiduals);
    const mad = 1.4826 * medAbsRes;
    const threshold = mad > 0 ? factorStd * mad : 1;
    const rawWeights = new Float64Array(absResiduals.length);
    for (let i = 0; i < absResiduals.length; i++) {
        rawWeights[i] = Math.exp(-((absResiduals[i] / threshold) ** 2));
    }
    const oneMinusLearningRate = 1 - learningRate;
    for (let i = 0; i < weights.length; i++) {
        let weight = weights[i];
        weight = (oneMinusLearningRate * weight + learningRate * rawWeights[i]) / 4;
        if (controlPoints && controlPoints[i] > 0) {
            weight *= 4;
        }
        weights[i] = weight;
    }
    weights[0] = 1;
    weights[weights.length - 1] = 1;
    return weights;
}
//# sourceMappingURL=calculateAdaptiveWeights.js.map